import { Component, input } from '@angular/core';
import { UnroadworthyDefectsResponse } from 'src/app/models/unroadworthy-defects.model';
import { CoreService } from 'src/app/services/core/core.service';

@Component({
  selector: 'app-unroadworthy-vehicle-banner',
  templateUrl: './unroadworthy-vehicle-banner.component.html',
  styleUrls: ['./unroadworthy-vehicle-banner.component.scss'],
  standalone: false,
})
export class UnroadworthyVehicleBannerComponent {
  /* Unroadworthy vehicle details used for banner display */
  vehicleDetails = input<UnroadworthyDefectsResponse | null>(null);

  constructor(
    private readonly coreService: CoreService
  ) { }

  /* Indicates whether the application is running in mobile context */
  get isMobileApp(): boolean {
    return this.coreService.isMobileApp;
  }

}
